import {
  Box,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import React, { useState } from "react";
import styles from "./styles";
import PdfIcon from "../../components/IconComp/pdfIcon";
import { CustomPagination } from "../../components/commontable/customPagination";
import EditIcon from "../../components/IconComp/editIcon";
import ViewIcon from "../../components/IconComp/viewIcon";
import { NewSaleEntry } from "../../components/sales/newSaleEntry";

interface IProps {
  headerData: any;
  rowData: any;
  onRowClick: any;
  onActionClick: any;
  page?: number;
  rowsPerPage?: number;
  totalCount?: number;
  onPageChange?: any;
  onRowsPerPageChange?: any;
  isPagination?: any;
  showEditIcon?: boolean;
  getSalesHistory?: any;
  setOpenSnackbar?: any;
}

const SalesHistoryTable = ({
  rowData,
  headerData,
  onRowClick,
  onActionClick,
  page,
  rowsPerPage,
  totalCount,
  onPageChange,
  onRowsPerPageChange,
  isPagination,
  showEditIcon,
  getSalesHistory,
  setOpenSnackbar,
}: IProps) => {
  const [editRowIndex, setEditRowIndex] = useState<number | null>(null);
  const [editInvoiceId, setEditInvoiceId] = useState(null);

  function handleEdit(rowIndex: number, row: any) {
    setEditRowIndex(rowIndex);
    setEditInvoiceId(row?.Id);
  }
  function handleCloseEditFunction() {
    setEditRowIndex(null);
  }
  return (
    <>
      <Box sx={styles.boxMarginTop}></Box>
      <TableContainer
        component={Paper}
        sx={styles.tableContainer(showEditIcon || false)}
      >
        <Table aria-label="simple table" sx={styles.table} stickyHeader>
          <TableHead sx={styles.tableHead}>
            <TableRow>
              {headerData?.map((headerItem: any, index: any) => (
                <TableCell key={index} sx={styles.tableCellHeader(headerItem)}>
                  {headerItem}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rowData?.map((row: any, rowIndex: any) => (
              <React.Fragment key={rowIndex}>
                <TableRow
                  key={rowIndex}
                  onClick={() => onRowClick(row)}
                  sx={styles.tableRowClickable}
                >
                  {headerData.map((headerItem: any, colIndex: any) => (
                    <TableCell key={colIndex} sx={styles.tableCellBody}>
                      {headerItem === "Action" ? (
                        <Box sx={styles.actionBox}>
                          {showEditIcon && (
                            <Tooltip title="Edit Details">
                              <IconButton
                                aria-label="edit"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleEdit(rowIndex, row);
                                }}
                              >
                                <EditIcon />
                              </IconButton>
                            </Tooltip>
                          )}
                          {!showEditIcon && (
                            <Tooltip title="View Details">
                              <IconButton
                                aria-label="view"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  onRowClick(row); // Trigger the same click as row click
                                }}
                              >
                                <ViewIcon />
                              </IconButton>
                            </Tooltip>
                          )}
                          <Tooltip title="Print Invoice">
                            <IconButton
                              aria-label="view"
                              onClick={(e) => {
                                e.stopPropagation();
                                onActionClick(
                                  row["Id"],
                                  row["sales"],
                                  row["return"]
                                );
                              }}
                            >
                              <PdfIcon />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      ) : (
                        row[headerItem]
                      )}
                    </TableCell>
                  ))}
                </TableRow>
                {editRowIndex === rowIndex && (
                  <TableRow>
                    <TableCell
                      colSpan={headerData.length}
                      sx={styles.editRowCell(headerData.length)}
                    >
                      <Box sx={styles.editRowBox}>
                        <NewSaleEntry
                          initialSalesData={row?.sales}
                          handleCloseEditFunction={handleCloseEditFunction}
                          editInvoiceId={editInvoiceId}
                          getSalesHistory={getSalesHistory}
                          setOpenSnackbar={setOpenSnackbar}
                        />
                      </Box>
                    </TableCell>
                  </TableRow>
                )}
              </React.Fragment>
            ))}
          </TableBody>
        </Table>

        {/* Fixed pagination with proper type handling */}
      </TableContainer>
      {isPagination ? null : (
        <Box sx={styles.paginationBox}>
          <CustomPagination
            totalCount={totalCount}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={onPageChange}
            onRowsPerPageChange={onRowsPerPageChange}
          />
        </Box>
      )}
    </>
  );
};

export default SalesHistoryTable;
